import { render } from "./CompanyProfileDownload.vue?vue&type=template&id=8e1b8a28&scoped=true"
import script from "./CompanyProfileDownload.vue?vue&type=script&lang=js"
export * from "./CompanyProfileDownload.vue?vue&type=script&lang=js"

import "./CompanyProfileDownload.vue?vue&type=style&index=0&id=8e1b8a28&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8e1b8a28"

export default script